export default __webpack_public_path__ + "static/HelveticaMonospacedPro-Rg-fb5e0b6fe81c021401b59f44d0b1ffe4.woff2";